import { MapBuilder, px, type Decor, type MapDef } from '../mapdef';

/** Sports centre: a gym hall with a volleyball court, the indoor pool, and the lobby. */
const b = new MapBuilder(34, 22, ' ');
b.room(0, 0, 34, 22, ',');
b.room(0, 0, 18, 16, '.'); // gym
b.room(17, 0, 17, 16, 'b'); // pool hall
b.room(11, 15, 12, 7, ','); // lobby
b.fill(13, 15, 2, 1, 'd').fill(19, 15, 2, 1, 'd');
b.fill(15, 21, 2, 1, 'D');
b.fill(20, 3, 12, 10, 'P'); // pool

const box = (tx: number, ty: number, tw: number, h = 10): Decor['solid'] => ({ x: px(tx) + 1, y: px(ty) - h, w: px(tw) - 2, h });
const decor: Decor[] = [
  { kind: 'gymCourt', x: px(2), y: px(2), w: px(14), h: px(12) },
  { kind: 'scoreboard', x: px(6), y: 1, wall: true },
  { kind: 'window', x: px(23), y: 0, w: px(6), wall: true },
  { kind: 'lifeguardChair', x: px(18) + 8, y: px(8), solid: box(18, 8, 1, 10) },
  { kind: 'lockers', x: px(14) + 8, y: px(17), w: px(3), solid: box(13, 17, 3, 8) },
  { kind: 'benchIndoor', x: px(19) + 8, y: px(18) + 4, solid: box(18, 18.25, 3, 6) },
  { kind: 'pottedPlant', x: px(12) + 8, y: px(20) + 12, solid: { x: px(12) + 2, y: px(20) + 6, w: 12, h: 6 } },
  { kind: 'pottedPlant', x: px(21) + 8, y: px(20) + 12, solid: { x: px(21) + 2, y: px(20) + 6, w: 12, h: 6 } },
  { kind: 'ballCart', x: px(2) + 8, y: px(14) + 4, solid: box(1.5, 14.25, 1, 8) },
];

export const sports: MapDef = {
  id: 'sports',
  w: b.w,
  h: b.h,
  rows: b.rows(),
  indoor: true,
  theme: { wallFace: '#e8eef2', wallLight: '#ffffff', wainscot: '#4f8fc0', wallTop: '#26303a' },
  doors: [{ tiles: [[15, 21], [16, 21]], to: 'town', arrive: { x: px(73), y: px(10) + 4, facing: 'down' } }],
  decor,
  areas: [
    { key: 'gym', rect: { x: 0, y: 0, w: px(17), h: px(15) } },
    { key: 'pool', rect: { x: px(17), y: 0, w: px(17), h: px(15) } },
    { key: 'sportsCenter', rect: { x: 0, y: 0, w: px(34), h: px(22) } },
  ],
  lights: [
    { x: px(8), y: px(7), r: 130, color: '255,248,230' },
    { x: px(25), y: px(7), r: 130, color: '230,248,255' },
    { x: px(16), y: px(18), r: 80, color: '255,240,210' },
  ],
};
